import { translation } from '@hh.ru/front-static-app';
import Gap from 'bloko/blocks/gap';
import { H1 } from 'bloko/blocks/header';
import { TranslatedComponent } from 'bloko/common/hooks/useTranslations';

import { NON_BREAKING_SPACE } from 'src/constants/symbols';

import styles from 'src/components/PageIsNotAvailableMessage/page-is-not-available-message.less';

const TrlKeys = {
    header: 'statportal.pageIsNotAvailable.message.header',
    soon: 'statportal.pageIsNotAvailable.message.soon',
    follow: 'statportal.pageIsNotAvailable.message.follow',
};

interface PageIsNotAvailableMessageProps {
    pageName: string;
    link: string;
}

const PageIsNotAvailableMessage: TranslatedComponent<PageIsNotAvailableMessageProps> = ({ link, pageName, trls }) => {
    return (
        <div className={styles.pageIsNotAvailableMessage} data-qa="page-is-not-available-message">
            <H1>{trls[TrlKeys.header]}</H1>
            <Gap top bottom>
                <p>
                    {trls[TrlKeys.soon]}
                    {NON_BREAKING_SPACE}
                    <a href={link} target="_blank" rel="noreferrer">
                        {pageName}
                    </a>
                    .
                </p>
            </Gap>
            <p>{trls[TrlKeys.follow]}</p>
        </div>
    );
};

export default translation(PageIsNotAvailableMessage);
